import { __extends } from "tslib";
import { ImportInstanceRequest, ImportInstanceResult } from "../models/models_4";
import { deserializeAws_ec2ImportInstanceCommand, serializeAws_ec2ImportInstanceCommand } from "../protocols/Aws_ec2";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
/**
 * <p>Creates an import instance task using metadata from the specified disk image. <code>ImportInstance</code> only
 *    supports single-volume VMs. To import multi-volume VMs, use <a>ImportImage</a>. For more information, see
 *     <a href="https://docs.aws.amazon.com/AWSEC2/latest/CommandLineReference/ec2-cli-vmimport-export.html">Importing a
 *     Virtual Machine Using the Amazon EC2 CLI</a>.</p>
 *          <p>For information about the import manifest referenced by this API action, see <a href="https://docs.aws.amazon.com/AWSEC2/latest/APIReference/manifest.html">VM Import Manifest</a>.</p>
 */
var ImportInstanceCommand = /** @class */ (function (_super) {
    __extends(ImportInstanceCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function ImportInstanceCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    ImportInstanceCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "EC2Client";
        var commandName = "ImportInstanceCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: ImportInstanceRequest.filterSensitiveLog,
            outputFilterSensitiveLog: ImportInstanceResult.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    ImportInstanceCommand.prototype.serialize = function (input, context) {
        return serializeAws_ec2ImportInstanceCommand(input, context);
    };
    ImportInstanceCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_ec2ImportInstanceCommand(output, context);
    };
    return ImportInstanceCommand;
}($Command));
export { ImportInstanceCommand };
//# sourceMappingURL=ImportInstanceCommand.js.map